import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import TickIcon from 'images/icons/tick.svg'

const StepButton = ({ currentStepIndex, step, onChangeStep, title }) => {
  function handleStepChange() {
    onChangeStep(step)
  }

  return (
    <button type="button" onClick={handleStepChange} className="step-content">
      <h2>{currentStepIndex > step + 1 ? <TickIcon /> : step + 1}</h2>
      <p>{title}</p>
    </button>
  )
}

StepButton.propTypes = {
  currentStepIndex: PropTypes.number,
  title: PropTypes.string,
  step: PropTypes.number,
  onChangeStep: PropTypes.func,
}

const Steps = ({ step, onChangeStep }) => (
  <div className="signup-container">
    <section className="steps-container">
      <div
        className={cx('step', {
          'is-active': step === 1,
          'is-complete': step > 1,
        })}
      >
        <div className="step-container">
          {step > 1 && step !== 4 ? (
            <StepButton
              title="Personal Details"
              currentStepIndex={step}
              step={0}
              onChangeStep={onChangeStep}
            />
          ) : (
            <div className="step-content">
              <h2>{step > 1 ? <TickIcon /> : 1}</h2>
              <p>Personal Details</p>
            </div>
          )}
        </div>
      </div>
      <div
        className={cx('step', {
          'is-active': step === 2,
          'is-complete': step > 2,
        })}
      >
        <div className="step-container">
          {step > 2 && step !== 4 ? (
            <StepButton
              title="Package & Payment"
              currentStepIndex={step}
              step={1}
              onChangeStep={onChangeStep}
            />
          ) : (
            <div className="step-content">
              <h2>{step > 2 ? <TickIcon /> : 2}</h2>
              <p>Package & Payment</p>
            </div>
          )}
        </div>
      </div>
      <div
        className={cx('step', {
          'is-active': step === 3,
          'is-complete': step > 3,
        })}
      >
        <div className="step-container">
          {step > 3 && step !== 4 ? (
            <StepButton
              title="Organization Details"
              currentStepIndex={step}
              step={2}
              onChangeStep={onChangeStep}
            />
          ) : (
            <div className="step-content">
              <h2>{step > 3 ? <TickIcon /> : 3}</h2>
              <p>Organization Details</p>
            </div>
          )}
        </div>
      </div>
    </section>
  </div>
)

Steps.propTypes = {
  step: PropTypes.number,
  onChangeStep: PropTypes.func,
}

export default Steps
